import styled from "styled-components";
import {
  DARK_GRAY,
  DARKER_GRAY,
  EARTH_GREEN,
  LIGHT_GRAY,
  RUBIK,
  WHITE,
} from "../../index.style.ts";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 30px 0;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: ${RUBIK};
`;

export const Intro = styled.p`
  margin: 0;
  color: ${DARK_GRAY};
  line-height: 1.5;
`;

export const Recommended = styled.div`
  background: ${WHITE};
  border: 1px solid ${LIGHT_GRAY};
  border-radius: 12px;
  padding: 18px;

  .label {
    font-size: 13px;
    color: ${DARK_GRAY};
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .value {
    font-size: 30px;
    font-family: ${RUBIK};
    color: ${EARTH_GREEN};
  }

  .sub {
    font-size: 13px;
    color: ${DARK_GRAY};
  }
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
  color: ${DARKER_GRAY};

  input,
  select {
    font-family: inherit;
    font-size: 15px;
    padding: 9px 10px;
    border: 1px solid ${LIGHT_GRAY};
    border-radius: 8px;
  }

  .hint {
    font-size: 12px;
    color: ${DARK_GRAY};
  }
`;

export const DrawRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;

  label {
    flex: 1;
  }
`;

export const Saved = styled.div`
  font-size: 13px;
  color: ${EARTH_GREEN};
`;
